<template>
  <div class="template">
    <RenduDesktop class="template__Desktop" />
    <RenduMobile class="template__Mobile" />
  </div>
</template>

<script>
import RenduMobile from '@/components/services/Rendu-realiste/RenduMobile.vue'
import RenduDesktop from '@/components/services/Rendu-realiste/RenduDesktop.vue'
export default {
  name: 'RenduView',
  components: {
    RenduDesktop,
    RenduMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>